import React from "react";

function Step({imageSrc, title, description}) {

  return (
    <div data-aos="fade-up" className="w-5/6 max-w-4xl mx-auto flex flex-col sm:flex-row justify-center items-center sm:justify-between sm:items-start mb-16 sm:mb-8">
      <img className="h-48 w-48 object-contain mb-8" src={imageSrc} alt="how-it-works-preview" />
      <div className="w-full sm:w-3/5">
        <h3 className="mb-4 font-bold text-xl md:text-2xl underline" style={{textDecorationColor: '#ECC94B'}}>
          {title}
        </h3>
        <p className="text-gray-700 text-lg sm:text-xl">
          {description}
        </p>
      </div>
    </div>
  )
}

export default Step;